import React, { useEffect, useState } from "react";
import Header from "../../../components/Header";
import SearchInputV2 from "../../../components/Ecommerce/SearchInputV2";
import SearchResultV2 from "../../../components/Ecommerce/SearchResultV2";
import { useSharedLinkParam } from "../../../hooks/useSharedLinkParam";
import { useWrongPlatformRedirect } from "../../../hooks/useWrongPlatformRedirect";
import FooterV2 from "../../../components/FooterV2";
import CashBackGuide from "../../../components/Ecommerce/CashBackGuide";
import tiktokApi from "../../../api/tiktokApi";
import FindButton from "../../../components/Ecommerce/FindButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlayCircle } from "@fortawesome/free-regular-svg-icons";
import AnswerQuestion from "../../../components/Q&A/Q&A";
import { Link } from "react-router-dom";
import LongHouseePet from "../../../components/Ecommerce/LongHouseePet";
// import PolicyTikTok from "../../../components/Ecommerce/PolicyTikTok";
import Policy from "../../../components/Ecommerce/Policy";
import useTikTokShoppingMode from "./hooks/useTikTokShoppingMode";

const guideVideoUrl = "https://www.youtube.com/watch?v=0qU_g5vmrxs";

function TikTokNew() {
  const [searchTerm, setSearchTerm] = useState("");
  // Link dán sẵn qua ?link= (block đợt thưởng, push giảm giá…) + câu nhắc thưởng thêm.
  const { initialLink, rewardNote } = useSharedLinkParam(searchTerm);
  useEffect(() => { if (initialLink) setSearchTerm(initialLink); }, [initialLink]);
  const [productList, setProductList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // Toggle admin: mode='link'&enabled → mua qua affiliate link RioHub (kèm chia sẻ).
  const { isLinkMode, loading: modeLoading } = useTikTokShoppingMode();

  // Dán nhầm sàn → mở trang đúng thay vì để API TikTok trả "không tìm thấy sản phẩm".
  const redirectIfWrongPlatform = useWrongPlatformRedirect("tiktok");

  useEffect(() => {
    // Chờ load xong toggle để biết chắc showcase hay link (tránh chạy nhầm showcase
    // rồi add-to-showcase trong khi đang ở link mode).
    if (!searchTerm || modeLoading) return;
    if (redirectIfWrongPlatform(searchTerm)) return;
    setProductList([]);
    const fetchProductInfoByLink = async () => {
      setIsLoading(true);
      try {
        const { data } = await tiktokApi.getProductInfo(searchTerm);
        const productInfo = data.productInfo;
        const { itemId } = productInfo;
        // Showcase mode: auto addToShowCase (đăng ký trưng bày). Link mode: KHÔNG
        // đăng ký — attribution qua affiliate link khi user bấm Mua.
        if (!isLinkMode && itemId) {
          await tiktokApi.addToShowCase(itemId, {
            productName: productInfo.productName,
            productImage: productInfo.imageUrl,
            productPrice: productInfo.price,
            shopName: productInfo.shopName,
            commission: productInfo.commission,
          });
        }
        setProductList(() => [{ ...productInfo, productLink: productInfo.productLink || searchTerm }]);
      } catch (error) {
        console.log(error);
        setProductList([]);
      }
      setIsLoading(false);
    };
    fetchProductInfoByLink();
  }, [searchTerm, isLinkMode, modeLoading, redirectIfWrongPlatform]);

  return (
    <div className="h-dvh flex flex-col justify-between">
      <Header />
      <div className="pt-16 w-full md:w-[768px] lg:w-[1024px] mx-auto flex flex-col gap-2">
        <div>
          <SearchInputV2
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            isLoading={isLoading}
            platform={"tiktok"}
            cashBackTitle={
              <span className="text-xs">
                🔗 Dán link → 🛒 Mua và dán mã đơn → 💰 Rút tiền sau 7 ngày
              </span>
            }
            titleTextColor={"text-rose-800"}
            borderInputColor={"border-rose-800"}
          />
        </div>
        {!searchTerm && <LongHouseePet platform={"TikTok"} />}
        {searchTerm && (
          <SearchResultV2
                            rewardNote={rewardNote}
            isLoading={isLoading}
            platform={"tiktok"}
            productList={productList}
            fromColorBg={"from-rose-500"}
            toColorBg={"to-rose-800"}
            buyBtnBgColor={"bg-rose-800"}
            buyBtnTextColor={"text-rose-800"}
            cashBackTextColor={"text-white"}
            tiktokLinkMode={isLinkMode}
          />
        )}

        <>
          <FindButton
            fromColorBg={"from-rose-200"}
            toColorBg={"to-rose-900"}
            fromColorText={"from-black"}
            toColorText={"to-black"}
            platform={"tiktok"}
          />
          <div className="p-2 bg-surface text">
            <CashBackGuide
              fromColorBg={"from-rose-500"}
              toColorBg={"to-rose-800"}
              platform="tiktok"
              isLinkMode={isLinkMode}
            />
          </div>
          {/* Video hướng dẫn = luồng trưng bày (bước 3,4). Ẩn khi mua qua link. */}
          {!isLinkMode && (
            <div className="h-28 flex justify-between bg-surface">
              <div className="flex justify-center text-sm items-center flex-col w-1/2 font-semibold text-center">
                <p className="">VIDEO HƯỚNG DẪN</p>
                <p> HOÀN TIỀN TỪ TIKTOK</p>
              </div>
              <div className="p-2 w-1/2">
                <Link
                  to={guideVideoUrl}
                  target="_blank"
                  className="h-full overflow-hidden relative"
                >
                  <img
                    src="img/longhousee_guide_thumb.jpeg"
                    alt="video"
                    className="h-full w-full object-cover rounded-lg"
                  />
                  <div className="absolute top-0 h-full w-full opacity-30 bg-gray-500 rounded-lg"></div>
                  <div className="absolute top-0 h-full w-full flex justify-center items-center text-white text-4xl">
                    <FontAwesomeIcon icon={faPlayCircle} />
                  </div>
                </Link>
              </div>
            </div>
          )}
          <Policy fromColorBg={"from-rose-500"} toColorBg={"to-rose-800"} />
        </>
        <div className="p-2">
          <AnswerQuestion
            postId={12}
            fromColorBg={"from-rose-500"}
            toColorBg={"to-rose-800"}
          />
        </div>
      </div>
      <FooterV2 />
    </div>
  );
}

export default TikTokNew;
